import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

//import { Logger } from './utils/logger';

// import TagManager from 'react-gtm-module';

/*
const tagManagerArgs = {
  gtmId: 'GTM-TCH3M4TF',
};

TagManager.initialize(tagManagerArgs);
*/

/*
if (window.top && !window.top.location.origin.includes('localhost') && window.top !== window.self) {
  Logger.log('Inside an iframe, busting out');
  window.top.location.href = window.self.location.href;
}
*/

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
